import { Modal } from "@circleco/compass/components/Modal";
import { Typography } from "@circleco/compass/components/Typography";

import { t } from "@/i18n-js/instance";
import {
  ModalManager,
  useModal,
} from "@/react/components/Layout/ModalManagerProvider";

interface DiscardChangesModalProps {
  cancelLabel?: string;
  confirmLabel?: string;
  description?: string;
  onCancel?: () => void;
  onConfirm: () => void;
  title?: string;
}

const I18N_ROOT = "discard_changes_modal";

const DiscardChangesModalComponent = ({
  onConfirm,
  onCancel,
  title,
  description,
  confirmLabel,
  cancelLabel,
}: DiscardChangesModalProps) => {
  const modal = useModal();

  const handleConfirm = () => {
    onConfirm();
    void modal.hide();
  };

  const handleOpenChange = (open: boolean) => {
    if (open) return;

    onCancel?.();
    void modal.hide();
  };

  return (
    <Modal.Root open={modal.visible} onOpenChange={handleOpenChange} size="sm">
      <Modal.Content>
        <Modal.Header
          title={title ?? t([I18N_ROOT, "title"])}
          showCloseButton
        />
        <Modal.Body>
          <Typography variant="body-sm">
            {description ?? t([I18N_ROOT, "description"])}
          </Typography>
        </Modal.Body>
        <Modal.Footer
          secondaryAction={{
            label: cancelLabel ?? t("cancel"),
          }}
          primaryAction={{
            label: confirmLabel ?? t([I18N_ROOT, "confirm"]),
            variant: "destructive",
            onClick: handleConfirm,
          }}
        />
      </Modal.Content>
    </Modal.Root>
  );
};

const DiscardChangesModal = ModalManager.create(
  (props: DiscardChangesModalProps) => (
    <DiscardChangesModalComponent {...props} />
  ),
);

export const useDiscardChangesModal = () => useModal(DiscardChangesModal);
